import { render, staticRenderFns } from "./SectionUseful.vue?vue&type=template&id=d2c89104&scoped=true&"
import script from "./SectionUseful.vue?vue&type=script&lang=js&"
export * from "./SectionUseful.vue?vue&type=script&lang=js&"
import style0 from "./SectionUseful.vue?vue&type=style&index=0&id=d2c89104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c89104",
  null
  
)

export default component.exports